import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';

import { FavoriteIcon } from 'components/favorite-icon';
import { Box } from 'components/ui';
import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

import { StoreCardButton } from './store-card-button';

interface StoreCardActionsProps {
  onDiagnosticsClick?: () => void;
  onFavoritesClick?: () => void;
  onInfoPress?: () => void;
  isUpdatingFavorites?: boolean;
  isFavorite?: boolean;
  canBeSelected: boolean;
  containerStyle?: StyleProp<ViewStyle>;
}

export const StoreCardActions: React.FC<StoreCardActionsProps> = ({
  onDiagnosticsClick,
  onFavoritesClick,
  onInfoPress,
  isUpdatingFavorites,
  isFavorite,
  canBeSelected,
  containerStyle,
}) => {
  const { isAuthenticated } = useAuthContext();

  return (
    <Box style={[styles.container, containerStyle]}>
      {onDiagnosticsClick && (
        <StoreCardButton
          testID="store-favorite-button"
          accessibilityLabel="Open a diagnostic modal for this store"
          onPress={onDiagnosticsClick}
          icon={<Icon variant="settings" />}
        />
      )}
      {onInfoPress && canBeSelected && (
        <StoreCardButton
          accessibilityLabel={t('info')}
          onPress={onInfoPress}
          icon={<Icon size="$5" variant="info" aria-hidden />}
        />
      )}
      {isAuthenticated && onFavoritesClick && (
        <StoreCardButton
          accessibilityLabel={isFavorite ? t('removeFavorite') : t('setRestaurantAsFavorite')}
          onPress={onFavoritesClick}
          icon={<FavoriteIcon loading={isUpdatingFavorites} isFavorite={isFavorite} />}
          isDisabled={isUpdatingFavorites}
        />
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: spacing.$4,
  },
});
